<template>
  <v-row>
    <v-col cols="6">
      <v-text-field
        v-model="data.client_name"
        label="Client Name"
      ></v-text-field>
    </v-col>
    <v-col cols="6">
      <v-text-field
        v-model="data.business_name"
        label="Business Name"
      ></v-text-field>
    </v-col>
    <v-col cols="6">
      <v-text-field v-model="data.website" label="Website"></v-text-field>
    </v-col>
    <v-card flat width="100%">
      <v-card-title>
        Address
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="4">
            <v-text-field v-model="data.unit" label="Unit no"></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="data.street"
              label="Street name"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <select-suburbs v-model="data.suburb"></select-suburbs>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card flat width="100%">
      <v-card-title>
        Contact
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="4">
            <v-text-field
              v-model="data.telephone"
              label="Telephone"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field v-model="data.mobile" label="Mobile"></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field v-model="data.email" label="Email"></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-col cols="6">
      <v-text-field v-model="data.abn" label="ABN"></v-text-field>
    </v-col>
    <v-col cols="6">
      <v-text-field v-model="data.acn" label="ACN"></v-text-field>
    </v-col>
    <v-col cols="12">
      <v-textarea label="Notes" v-model="data.notes"></v-textarea>
    </v-col>
  </v-row>
</template>

<script>
import SelectSuburbs from '../../../../components/SelectSuburbs'
export default {
  name: 'ClientForm',
  props: ['data'],
  components: {
    SelectSuburbs
  }
}
</script>

<style scoped></style>
